// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-text-field--outlined fieldset[data-v-050cecb0]{border:2px!important}.freeWebOrStructuredDocumentViewer[data-v-050cecb0]{max-height:calc(100vh - 189px)}.otherTypesDocumentViewer[data-v-050cecb0]{max-height:calc(100vh - 247px)}.mobileMaxHeight[data-v-050cecb0]{max-height:calc(100vh - 145px)}.maxWidth[data-v-050cecb0]{width:100%}.disableCursor[data-v-050cecb0]{pointer-events:none!important}", ""]);
// Exports
module.exports = exports;
